// app/components/chat/chatThread.tsx
import type { ChatCard } from '~/.server/chat/orchestrator.server';
import type { SlotName } from '~/.server/chat/slots';
import { cn } from '~/lib/utils';
import { RecommendationCard } from './wizardStep';

export type ChatMessage =
  | { id: string; role: 'bot'; slot?: SlotName; text: string; hint?: string }
  | { id: string; role: 'user'; text: string }
  | { id: string; role: 'bot-cards'; text: string; cards: ChatCard[]; confirmation: string };

function Avatar() {
  return (
    <div className="flex flex-shrink-0 items-center justify-center self-end rounded-md bg-neutral-900 text-[10px] font-bold text-white"
         style={{ height: 26, width: 26 }}>
      CE
    </div>
  );
}

export function TypingIndicator() {
  return (
    <div className="flex items-end gap-2 self-start">
      <Avatar />
      <div className="flex items-center gap-1 rounded-2xl rounded-bl-sm bg-neutral-100 px-3.5 py-3">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="inline-block h-1.5 w-1.5 animate-bounce rounded-full bg-neutral-400"
            style={{ animationDelay: `${i * 0.15}s` }}
          />
        ))}
      </div>
    </div>
  );
}

export function MessageBubble({ message }: { message: ChatMessage }) {
  if (message.role === 'user') {
    return (
      <div className="flex max-w-[88%] items-end gap-2 self-end">
        <div className="rounded-2xl rounded-br-sm bg-neutral-900 px-3 py-2 text-sm text-white">
          {message.text}
        </div>
      </div>
    );
  }

  if (message.role === 'bot-cards') {
    return (
      <div className="flex flex-col gap-2.5 self-stretch">
        <div className="flex max-w-[88%] items-end gap-2 self-start">
          <Avatar />
          <div className="rounded-2xl rounded-bl-sm bg-neutral-100 px-3 py-2 text-sm text-neutral-900">
            {message.text}
          </div>
        </div>
        <div className="ml-8 flex flex-col gap-2.5">
          {message.cards.map((card) => (
            <RecommendationCard key={card.id} card={card} />
          ))}
        </div>
        <div className="ml-8 flex items-center gap-3 rounded-xl border-2 border-green-200 bg-green-50 px-4 py-3">
          <p className="text-sm text-neutral-700">{message.confirmation}</p>
        </div>
      </div>
    );
  }

  // role === 'bot'
  return (
    <div className="flex max-w-[88%] items-end gap-2 self-start">
      <Avatar />
      <div className={cn('rounded-2xl rounded-bl-sm bg-neutral-100 px-3 py-2 text-sm text-neutral-900')}>
        <p>{message.text}</p>
        {message.hint && <p className="mt-1 text-xs text-neutral-500">{message.hint}</p>}
      </div>
    </div>
  );
}
